var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"video"}},[_c('vue-aliplayer-v2',{ref:"VueAliplayerV2",staticClass:"video",attrs:{"options":_vm.options},on:{"play":_vm.onPlayerPlay,"pause":_vm.onPlayerPause,"ended":_vm.onPlayerEnded}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00b6411a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/video.vue
// module id = null
// module chunks = 